import { render, staticRenderFns } from "./JournalVouchersTable.vue?vue&type=template&id=2b924526&scoped=true"
import script from "./JournalVouchersTable.vue?vue&type=script&lang=js"
export * from "./JournalVouchersTable.vue?vue&type=script&lang=js"
import style0 from "./JournalVouchersTable.vue?vue&type=style&index=0&id=2b924526&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b924526",
  null
  
)

export default component.exports